let currentLanguage = "en";

const listeners = [];

export function getLanguage() {
  return currentLanguage;
}

export function setLanguage(lang) {
  currentLanguage = lang;

  // Save language
  localStorage.setItem("language", lang);

  // Notify all pages/components
  listeners.forEach((listener) => listener(lang));
}

export function subscribeLanguage(listener) {
  listeners.push(listener);

  return () => {
    const index = listeners.indexOf(listener);

    if (index > -1) {
      listeners.splice(index, 1);
    }
  };
}

// Load saved language
const saved = localStorage.getItem("language");

if (saved) {
  currentLanguage = saved;
}